import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { ReactSortable } from "react-sortablejs";
import { FormikErrors } from "formik";
import { Col, Input, Label, Spinner } from "reactstrap";
import ModalConfirm from "./ModalConfirm";
import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import { toast } from "react-toastify";
import DropdownStatusNew from "./DropdownStatusNew";
import { LIST_OPTION_GENDER } from "helpers/constans";

interface AuditionRoleFormArrayProps {
  formik: any;
  // id?: any;
  // onUpdate?: any;
}

const PARAM_DEFAULT = {
  role_name: "",
  min_age: "",
  max_age: "",
  gender: "MALE",
  isRequired: false,
};

const AuditionRoleFormArray = ({
  formik = "",
}: // id,
// onUpdate,
AuditionRoleFormArrayProps) => {
  const { t } = useTranslation();
  const [isOpenConfirm, setIsOpenConfirm] = useState<boolean>(false);
  const [indexDelete, setIndexDelete] = useState<any>(null);
  const [funcDeleteDetail, setFuncDeleteDetail] = useState<any>(null);
  const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);

  // const handleChangeSort = (data: any[]) => {
  //   const formatData = data?.map((item, index) => ({
  //     group: item?.group,
  //     gender: item?.gender,
  //     description: item?.description,
  //     name: item?.name,
  //     id: item?.id,
  //   }));
  //   formik.setFieldValue("audition_role", formatData);
  // };
  const onCloseConfirmClick = () => {
    setIsOpenConfirm(false);
    setIndexDelete(null);
    setIsConfirmLoading((_prev) => false);
  };

  // const handleSubmit = async () => {
  //   setIsLoading(true);
  //   onUpdate && (await onUpdate());
  //   setIsLoading(false);
  // };

  const handleAddItem = () => {
    // const id =
    //   (formik?.values?.audition_role?.[
    //     formik?.values?.audition_role?.length - 1
    //   ]?.id || 0) + 1;
    const maxId =
      Math.max(...formik?.values?.audition_role.map((item: any) => item.idx)) ||
      0;

    const idx = maxId + 1;
    formik.setFieldValue("audition_role", [
      ...formik?.values?.audition_role,
      {
        ...PARAM_DEFAULT,
        idx,
      },
    ]);
  };

  const handleRemoveItem = (value: any) => {
    const updatedItems = formik?.values?.audition_role.filter(
      (i: any) => i?.idx !== value?.idx
    );

    formik.setFieldValue("audition_role", updatedItems);
  };

  const handleDeleteDetail = () => {
    if (funcDeleteDetail) {
      try {
        funcDeleteDetail();
        setIsOpenConfirm(false);
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } catch (error: any) {
        setIsConfirmLoading((_prev) => false);
        toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
        return error;
      } finally {
        setFuncDeleteDetail(null);
      }
      setIsConfirmLoading((_prev) => false);
    }
  };

  const handleActionDelete = async () => {
    try {
      handleRemoveItem(indexDelete);
      setIsOpenConfirm(false);
      toast(
        `${t("The process has been completed.")}`,
        CONFIG_OPTION_TOAST_NORMAL
      );
    } catch (error: any) {
      setIsConfirmLoading((_prev) => false);
      setIndexDelete(null);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
    setIsConfirmLoading((_prev) => false);
  };

  return (
    <React.Fragment>
      <>
        <Col lg={12}>
          {/* <Label htmlFor="titleKoreaInput" className="form-label">
            {t("Audition Role")} <span className="text-danger"></span>
          </Label> */}

          <table className="w-100">
            <thead>
              <tr style={{ background: "#EDEDED", height: "37px" }}>
                {/* <th style={{ minWidth: 25 }}></th> */}
                <th style={{ paddingLeft: "10px" }}>{t("Group")}</th>
                <th>{t("Quantity")}</th>
                <th>{t("Detail Role")}</th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            {/* <ReactSortable
              animation={200}
              delay={2}
              tag={"tbody"}
              filter={".locked_item"}
              preventOnFilter={false}
              list={formik?.values?.audition_role as any[]}
              setList={handleChangeSort}
              onMove={(evt) => !evt.related.classList.contains("locked_item")}
              handle={".my-handle"}
            > */}
            <tbody>
              {formik?.values?.audition_role?.map(
                (item: any, index: number) => {
                  return (
                    <React.Fragment key={"audition_role" + item?.id + index}>
                      <tr>
                        <td
                          style={{
                            paddingRight: "10px",
                            paddingTop: "5px",
                            paddingBottom: "5px",
                            width: "30%",
                            verticalAlign: "top",
                          }}
                        >
                          <DropdownStatusNew
                            name="group"
                            dataList={formik?.values?.role_group}
                            placeholder={`${t("Select Group")}...`}
                            className="dropdown-status-rounded p-0"
                            classNamePrefix="name-prefix"
                            initialValue={item?.field_role_group_id}
                            onChangeSelect={(event: any) =>
                              formik.setFieldValue(
                                `audition_role.${index}.field_role_group_id`,
                                event?.value
                              )
                            }
                            disabled={!formik?.values?.category}
                            // colors={COLOR_BAR_LIST_OPEN_STATUS}
                          />

                          {formik.touched.audition_role?.[index]
                            ?.field_role_group_id &&
                          formik?.values?.category &&
                          formik.errors.audition_role &&
                          (
                            formik.errors.audition_role[
                              index
                            ] as FormikErrors<any>
                          )?.field_role_group_id ? (
                            <small className="text-danger mt-2">
                              {
                                (formik.errors.audition_role[index] as any)
                                  ?.field_role_group_id
                              }
                            </small>
                          ) : null}
                        </td>
                        <td
                          style={{
                            paddingRight: "10px",
                            paddingTop: "5px",
                            paddingBottom: "5px",
                            verticalAlign: "baseline",
                            width: "20%",
                          }}
                        >
                          <Input
                            name={`audition_role.${index}.quantity`}
                            type="number"
                            className="form-control"
                            placeholder={t("Enter the quantity")}
                            value={item?.quantity}
                            disabled={!formik?.values?.category}
                            onBlur={(event) => {
                              formik.handleBlur(event);
                            }}
                            onChange={(event) => {
                              formik.setFieldValue(
                                `audition_role.${index}.quantity`,
                                event?.target?.value
                              );
                            }}
                          />
                          {formik.touched.audition_role?.[index]?.quantity &&
                          formik?.values?.category &&
                          formik.errors.audition_role &&
                          (
                            formik.errors.audition_role[
                              index
                            ] as FormikErrors<any>
                          )?.quantity ? (
                            <small className="text-danger mt-2">
                              {
                                (formik.errors.audition_role[index] as any)
                                  ?.quantity
                              }
                            </small>
                          ) : null}
                        </td>

                        <td
                          style={{
                            width: "50%",
                            verticalAlign: "top",
                            paddingTop: "15px",
                          }}
                        >
                          <div className="form-check form-switch">
                            <Input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id={`audition_role.${index}.role_detail`}
                              name={`audition_role.${index}.role_detail`}
                              disabled={!formik?.values?.category}
                              checked={!!item?.isDetail}
                              onChange={(event: any) => {
                                if (event?.target.checked) {
                                  formik.setFieldValue(
                                    `audition_role.${index}.role_detail`,
                                    [
                                      {
                                        ...PARAM_DEFAULT,
                                        idx: 1,
                                      },
                                    ]
                                  );
                                } else {
                                  formik.setFieldValue(
                                    `audition_role.${index}.role_detail`,
                                    []
                                  );
                                }

                                formik.setFieldValue(
                                  `audition_role.${index}.isDetail`,
                                  event?.target.checked
                                );
                              }}
                            />

                            <Label
                              className="form-check-label"
                              for={`audition_role.${index}.role_detail`}
                            >
                              {t("Detail Role")}
                            </Label>
                          </div>
                        </td>

                        <td>
                          <div
                            className="d-flex"
                            style={{ justifyContent: "center" }}
                          >
                            <div>
                              {
                                <div
                                  className="text-danger cursor-pointer"
                                  onClick={() => {
                                    setIsOpenConfirm(true);
                                    setIndexDelete(item);
                                    console.log("item", item);
                                  }}
                                >
                                  <i className="ri-delete-bin-3-fill align-bottom"></i>
                                </div>
                              }
                            </div>
                          </div>
                        </td>
                      </tr>
                      {item?.isDetail && (
                        <React.Fragment>
                          <tr>
                            <th
                              style={{
                                padding: "0 5px",
                              }}
                              className="d-flex align-items-center"
                            >
                              <div
                                className="d-flex align-items-end"
                                style={{ marginLeft: "20px", minWidth: "15px" }}
                              />
                              <div className="flex-grow-1">
                                {t("Role Name")}
                              </div>
                            </th>
                            <th
                              style={{
                                paddingRight: "10px",
                              }}
                            >
                              {t("Gender")}
                            </th>
                            <th
                              style={{
                                paddingRight: "10px",
                              }}
                            >
                              {t("Age Range")}
                            </th>
                            <th></th>
                            <th></th>
                          </tr>
                          {item?.role_detail?.map((element: any, i: number) => (
                            <tr key={"role_detail" + element?.id + i}>
                              <td
                                style={{
                                  padding: "5px 10px 5px 0",
                                  verticalAlign: "top",
                                }}
                                className="d-flex align-items-center"
                              >
                                <div
                                  className="d-flex align-items-end"
                                  style={{ marginLeft: "20px" }}
                                >
                                  <div
                                    style={{
                                      maxHeight: 1,
                                    }}
                                    className="d-flex align-items-end"
                                  >
                                    <div
                                      style={{
                                        height: "80px",
                                        width: 1,
                                        background: "#808080",
                                      }}
                                    />
                                  </div>
                                  <div
                                    style={{
                                      height: "1px",
                                      width: "15px",
                                      background: "#808080",
                                    }}
                                  />
                                </div>
                                <div className="flex-grow-1">
                                  <Input
                                    name={`audition_role.${index}.role_name`}
                                    type="text"
                                    className="form-control"
                                    placeholder={t("Enter role name")}
                                    value={element?.role_name || ""}
                                    onChange={(event) => {
                                      formik.setFieldValue(
                                        `audition_role.${index}.role_detail.${i}.role_name`,
                                        event?.target?.value
                                      );
                                    }}
                                  />

                                  {formik.touched.audition_role?.[index]
                                    ?.role_detail?.[i]?.role_name &&
                                  formik.errors?.audition_role &&
                                  formik.errors.audition_role?.[index]
                                    ?.role_detail?.[i]?.role_name ? (
                                    <small className="text-danger mt-2">
                                      {
                                        formik.errors.audition_role[index]
                                          ?.role_detail?.[i]?.role_name
                                      }
                                    </small>
                                  ) : null}
                                </div>
                              </td>
                              <td
                                style={{
                                  paddingRight: "10px",
                                  paddingTop: "5px",
                                  paddingBottom: "5px",
                                  verticalAlign: "top",
                                }}
                              >
                                <DropdownStatusNew
                                  name="gender"
                                  dataList={LIST_OPTION_GENDER}
                                  placeholder={`${t("Select gender")}...`}
                                  className="dropdown-status-rounded p-0"
                                  classNamePrefix="name-prefix"
                                  initialValue={element?.gender}
                                  onChangeSelect={(event: any) =>
                                    formik.setFieldValue(
                                      `audition_role.${index}.role_detail.${i}.gender`,
                                      event?.value
                                    )
                                  }
                                  // colors={COLOR_BAR_LIST_OPEN_STATUS}
                                />
                                {formik.touched.audition_role?.[index]
                                  ?.role_detail?.[i]?.gender &&
                                formik.errors?.audition_role &&
                                formik.errors.audition_role?.[index]
                                  ?.role_detail?.[i]?.gender ? (
                                  <small className="text-danger mt-2">
                                    {
                                      formik.errors.audition_role[index]
                                        ?.role_detail?.[i]?.gender
                                    }
                                  </small>
                                ) : null}
                              </td>
                              <td
                                style={{
                                  paddingRight: "10px",
                                  paddingTop: "5px",
                                  paddingBottom: "5px",
                                  verticalAlign: "top",
                                }}
                              >
                                <div className="d-flex gap-2">
                                  <div style={{ width: 120 }}>
                                    <Input
                                      name={`audition_role.${index}.role_detail.${i}.min_age`}
                                      type="number"
                                      className="form-control"
                                      placeholder={t("Enter min age")}
                                      value={element?.min_age}
                                      // onBlur={(event) => {
                                      //   formik.handleBlur(event);
                                      // }}
                                      onChange={(event) => {
                                        formik.setFieldValue(
                                          `audition_role.${index}.role_detail.${i}.min_age`,
                                          event?.target?.value
                                        );
                                      }}
                                    />
                                    {formik.touched.audition_role?.[index]
                                      ?.role_detail?.[i]?.min_age &&
                                    formik.errors?.audition_role &&
                                    formik.errors.audition_role?.[index]
                                      ?.role_detail?.[i]?.min_age ? (
                                      <small className="text-danger mt-2">
                                        {
                                          formik.errors.audition_role[index]
                                            ?.role_detail?.[i]?.min_age
                                        }
                                      </small>
                                    ) : null}
                                  </div>
                                  <div style={{ width: 120 }}>
                                    <Input
                                      name={`audition_role.${index}.role_detail.${i}.max_age`}
                                      type="number"
                                      className="form-control"
                                      placeholder={t("Enter max age")}
                                      value={element?.max_age}
                                      // onBlur={(event) => {
                                      //   formik.handleBlur(event);
                                      // }}
                                      onChange={(event) => {
                                        formik.setFieldValue(
                                          `audition_role.${index}.role_detail.${i}.max_age`,
                                          event?.target?.value
                                        );
                                      }}
                                    />
                                    {formik.touched.audition_role?.[index]
                                      ?.role_detail?.[i]?.max_age &&
                                    formik.errors.audition_role?.[index]
                                      ?.role_detail?.[i]?.max_age ? (
                                      <small className="text-danger mt-2">
                                        {
                                          formik.errors.audition_role[index]
                                            ?.role_detail?.[i]?.max_age
                                        }
                                      </small>
                                    ) : null}
                                  </div>
                                  <div className="form-check form-switch mt-2">
                                    <Input
                                      className="form-check-input"
                                      type="checkbox"
                                      role="switch"
                                      id="isHidePhone"
                                      name="isHidePhone"
                                      checked={!!element?.isRequired}
                                      onChange={(event: any) =>
                                        formik.setFieldValue(
                                          `audition_role.${index}.role_detail.${i}.isRequired`,
                                          event?.target.checked
                                        )
                                      }
                                    />

                                    <Label
                                      className="form-check-label"
                                      for="isHidePhone"
                                    >
                                      {t("Required")}
                                    </Label>
                                  </div>
                                </div>
                              </td>
                              <td style={{ verticalAlign: "top" }}>
                                <div
                                  className="d-flex"
                                  style={{
                                    justifyContent: "center",
                                    paddingTop: "10px",
                                  }}
                                >
                                  <div>
                                    {
                                      <div
                                        className="text-danger cursor-pointer"
                                        onClick={() => {
                                          setIsOpenConfirm(true);
                                          setFuncDeleteDetail(() => {
                                            return () => {
                                              const arr =
                                                item?.role_detail?.filter(
                                                  (i: any) =>
                                                    i.idx !== element?.idx
                                                );

                                              formik.setFieldValue(
                                                `audition_role.${index}.role_detail`,
                                                arr
                                              );
                                            };
                                          });
                                        }}
                                      >
                                        <i className="ri-delete-bin-3-fill align-bottom"></i>
                                      </div>
                                    }
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ))}
                          <tr key={index}>
                            {/* <td /> */}
                            <td
                              style={{
                                padding: "5px 10px 5px 0",
                              }}
                              className="d-flex align-items-center"
                            >
                              <div
                                className="d-flex align-items-end"
                                style={{ marginLeft: "20px", minWidth: "15px" }}
                              ></div>
                              <div
                                className="btn btn-primary fs-6"
                                onClick={() => {
                                  const arr = item?.role_detail || [];
                                  const maxId =
                                    Math.max(
                                      ...arr.map((item: any) => item.idx)
                                    ) || 0;

                                  const idx = maxId + 1;
                                  arr.push({
                                    idx,
                                    role_name: "",
                                    gender: "MALE",
                                    min_age: "",
                                    max_age: "",
                                    isRequired: false,
                                  });
                                  formik.setFieldValue(
                                    `audition_role.${index}.role_detail`,
                                    arr
                                  );
                                }}
                              >
                                {t("Add sub-filed")}
                              </div>
                            </td>
                            <td />
                            <td />
                          </tr>
                        </React.Fragment>
                      )}
                      {formik.errors.audition_role &&
                      formik.errors.audition_role?.[index]?.role_detail ? (
                        <small className="text-danger mt-2">
                          {typeof formik.errors.audition_role[index]
                            ?.role_detail === "string" &&
                            formik.errors.audition_role[index]?.role_detail}
                        </small>
                      ) : null}
                      <tr
                        style={{
                          height: "20px",
                        }}
                      >
                        <td colSpan={4} className="">
                          <div
                            style={{
                              width: "100%",
                              height: "2px",
                              background: "#EDEDED",
                            }}
                          ></div>
                        </td>
                      </tr>
                    </React.Fragment>
                  );
                }
              )}
            </tbody>
            {/* </ReactSortable> */}
          </table>
        </Col>
        {formik.touched?.content && formik.errors?.content ? (
          <small className="text-danger mt-2">
            {typeof formik.errors?.content === "string" &&
              formik.errors?.content}
          </small>
        ) : null}

        {/* {id && (
          <div className="d-flex justify-content-end">
            <div onClick={handleSubmit} className="btn btn-primary fs-14">
              {isLoading ? (
                <Spinner size="sm" className="me-2"></Spinner>
              ) : (
                <i className="ri-login-circle-line align-bottom me-2 "></i>
              )}
              {t("Update")}
            </div>
          </div>
        )} */}
        <Col lg={12} className="mb-2">
          <div
            className={`${
              !formik?.values?.category ? "text-white" : "text-primary"
            } text-center cursor-pointer mt-3 d-flex align-items-center justify-content-center gap-2`}
            style={{
              fontSize: 30,
              background: !formik?.values?.category ? "gray" : "#0bcee91c",
            }}
            onClick={!formik?.values?.category ? () => {} : handleAddItem}
          >
            + <span style={{ fontSize: 14 }}>{t("Add Role")}</span>
          </div>
        </Col>
      </>

      <ModalConfirm
        header={t("Delete this role")}
        isOpen={isOpenConfirm}
        isLoading={isConfirmLoading}
        onClose={onCloseConfirmClick}
        onConfirm={funcDeleteDetail ? handleDeleteDetail : handleActionDelete}
      />
    </React.Fragment>
  );
};

export default AuditionRoleFormArray;
